import { Injectable } from '@angular/core';

export interface ConsoleError {
  id: number;
  message: string;
  stack?: string;
  timestamp: Date;
  expanded?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConsoleErrorService {
  private errors: ConsoleError[] = [];
  private nextId = 1;

  getErrors() {
    return this.errors;
  }

  addError(message: string, stack?: string) {
    this.errors.push({
      id: this.nextId++,
      message,
      stack,
      timestamp: new Date(),
      expanded: false
    });
  }

  removeError(id: number) {
    this.errors = this.errors.filter(e => e.id !== id);
  }

  clearAll() {
    this.errors = [];
  }

  toggleExpand(id: number) {
    const err = this.errors.find(e => e.id === id);
    if (err) err.expanded = !err?.expanded;
  }
}
